export default "__VITE_ASSET__Cj0AgJL5__"